import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './JobListing.scss';
import { isAdminControlMode } from '../../../Helpers/ui_helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/pro-light-svg-icons';
import { useHistory } from 'react-router-dom';

const JobListing = props => {
  const { job, ui, openJobApplicationModal } = props;
  const inAdminControlMode = isAdminControlMode(ui);
  const history = useHistory();

  const { title, summary, qualifications, stillAvailable } = job;
  const jobIsHiddenForRegularUsers = !stillAvailable || !(summary && qualifications);

  const [isExpanded, setIsExpanded] = useState(false);

  const goToJobPage = () => history.push(`/jobs/${job.id}`);
  const handleClick = () => {
    if (inAdminControlMode) openJobApplicationModal(job);
    else goToJobPage();
  };

  // filter jobs for regular users
  if (!inAdminControlMode && jobIsHiddenForRegularUsers) return null;
  return (
    <div className='job-listing-outer'>
      <div className='job-listing-inner'>
        <div className='expansion-header' onClick={() => setIsExpanded(!isExpanded)}>
          <div className='job-title'>{title}</div>
          <div className='expansion-right-side'>
            {jobIsHiddenForRegularUsers && <div className='hidden-indicator'>Hidden for User</div>}
            {isExpanded ? <FontAwesomeIcon icon={faMinus} /> : <FontAwesomeIcon icon={faPlus} />}
          </div>
        </div>

        {isExpanded && (
          <>
            <div className='job-summary-container'>
              <div>
                <div className='column-header'>About</div>
                <div className='column-body'>{summary || 'N/A'}</div>
              </div>

              <div>
                <div className='column-header'>Qualifications</div>
                <ul className='qualifications column-body'>
                  {qualifications?.length ? (
                    (qualifications || '').split('\n\n').map(qualification => (
                      <li className='qualification' key={`${title}-qualification-${qualification}`}>
                        {qualification}
                      </li>
                    ))
                  ) : (
                    <li className='qualification' key={`${title}-qualification-${qualifications}`}>
                      No qualifications listed
                    </li>
                  )}
                </ul>
              </div>
            </div>
            <div className='job-button-container'>
              <button onClick={handleClick} className='rounded-button'>
                {inAdminControlMode ? 'Update Position' : 'More on this role'}
              </button>
              {isAdminControlMode(ui) && (
                <button onClick={goToJobPage} className='rounded-button'>
                  View Listing
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

JobListing.propTypes = {
  ui: PropTypes.object.isRequired,
  job: PropTypes.object.isRequired,
  openJobApplicationModal: PropTypes.func.isRequired
};

export default JobListing;
